<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <h1
      v-if="actionType === 'edit'"
      class="text-primary mb-5 font-45px mt-xl-2"
    >
      {{ $t("documents_informations") }}
    </h1>

    <!-- <b-row>
      <b-col
        :cols="actionType === 'edit' ? 12 : null"
        :xl="actionType === 'edit' ? 10 : null"
        :offset-xl="actionType === 'edit' ? 1 : null"
      > -->
    <div class="giga-upload_files_list">
      <template v-for="document in documents">
        <div
          class="giga-upload_file_item"
          v-if="document.fileName"
          :key="document.fileName"
        >
          <div class="giga-upload_file_action"></div>
          <div class="giga-upload_file_name">
            <i class="extention-icon">
              <img
                v-if="getFileExtention(document.originalFileName) == 'xlsx'"
                src="~@/assets/images/extensions/xls.svg"
              />
              <img
                v-else-if="getFileExtention(document.originalFileName) == 'txt'"
                src="~@/assets/images/extensions/txt.svg"
              />
              <img
                v-else-if="getFileExtention(document.originalFileName) == 'pdf'"
                src="~@/assets/images/extensions/pdf.svg"
              />
              <img
                v-else-if="
                  getFileExtention(document.originalFileName) == 'docx'
                "
                src="~@/assets/images/extensions/doc.svg"
              />
              <img
                v-else-if="getFileExtention(document.originalFileName) == 'doc'"
                src="~@/assets/images/extensions/doc.svg"
              />
              <img
                v-else-if="getFileExtention(document.originalFileName) == 'zip'"
                src="~@/assets/images/extensions/zip.svg"
              />
              <img v-else src="~@/assets/images/extensions/text.svg" />
            </i>
            {{ document.originalFileName }}
          </div>
          <div class="giga-upload_file_date">
            {{ new Date().toLocaleDateString("fr-FR") }}
          </div>
          <div class="giga-upload_file_type">
            <multiselect
              v-select-overflow
              open-direction="bottom"
              :searchable="false"
              :closeOnSelect="false"
              v-model="document.types"
              :options="getDocumentsTypes"
              :placeholder="$t('type_document')"
              :multiple="false"
              trackBy="code"
              label="name"
              :showLabels="false"
              class="tags-outline multiselect__type"
              :isRequired="true"
              :errorMsg="$t('required_field')"
              :is-doc-type="true"
              @input="handleChangeTypes(document)"
            >
              <template slot="caret">
                <div
                  class="
                            multiselect__select
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                >
                  <div
                    v-if="document.types && document.types.length"
                    class="text-primary"
                  >
                    <b-icon icon="pencil-fill"></b-icon>
                  </div>
                  <div v-else>
                    <b-icon icon="chevron-down"></b-icon>
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc d-flex justify-content-between">
                  <span class="option__title">{{ $t(props.option.name) }}</span>
                  <span
                    class="option__info-icon right"
                    :desc="props.option.info"
                  >
                    <b-icon class="text-muted" icon="info-circle"></b-icon>
                  </span>
                </div>
              </template>
              <template v-slot:selection="{ values }">
                <span
                  v-for="type in values"
                  :key="type.code"
                  class="multiselect__placeholder"
                >
                  {{ type.name }}
                </span>
              </template>
            </multiselect>
          </div>
          <div
            class="giga-upload_file_actions"
            @click="showOperation(document)"
          >
            <span
              class="cursor-pointer bg-gray-200 p-2 rounded hover:bg-gray-300 font-weight-bold"
              :class="{
                'bg-custom':
                  operationClick === document.fileName &&
                  selectedOperations.get(document.fileName),
                'bg-gray-200': operationClick !== document.fileName
              }"
            >
              <img src="@/assets/images/files.svg" alt="" />
              {{ getNbrOperations(document.fileName) }}
            </span>
          </div>
          <div class="giga-upload_file_actions menu-container">
            <span
              class="material-symbols-outlined menu-icon"
              @click="toggleMenu(document.fileName)"
              >more_vert</span
            >
            <div
              v-if="selectedDocumentName === document.fileName"
              class="dropdown-menu"
            >
              <button
                @click="assignDocument(document)"
                :class="{
                  'no-pointer-events': isTypeDocumentSelected(document)
                }"
              >
                Joindre aux opérations
              </button>
              <button @click="downloadFile(document)">
                Télécharger
              </button>
              <button @click="showDocument(document)">Visualiser</button>
              <button @click="doOpenConfirmModal(document)">
                Supprimer
              </button>
            </div>
          </div>
          <div
            v-if="
              operationClick === document.fileName &&
                selectedOperations.get(document.fileName)
            "
          >
            <OperationList
              :operations="selectedDocument.operations"
              :isDeleted="true"
              @operation-deleted-changed.capture="deleteOperation"
              :document="selectedDocument"
              :is-simulation="isSimulation"
              class="p-2 pl-5"
              :selected-document="selectedDocument"
            ></OperationList>
          </div>
        </div>
      </template>

      <assign-document-operation
        modal-id="assignDocumentOperation"
        fontSize="h3"
        backdrop-close="false"
        @selectedOperations="handleSelectedOperations"
        :selectedDocument="selectedDocument"
        :selected-operations="selectedDocumentOperations"
        :is-mass-actions="false"
        :is-simulation="isSimulation"
      ></assign-document-operation>

      <confirm-modal
        id="confirm-delete"
        :content="$t('would-you-like-to-delete-the-document')"
        :loader="false"
        fontSize="h3"
        backdrop-close="false"
        @yesClick="deleteDocument()"
        @close="hideConfirmationModal()"
      ></confirm-modal>
    </div>
    <!-- <b-card
          class="border-raduis-xl border-color-muted box-shadow-sm"
          body-class="py-sm-5"
        > -->
    <VuePerfectScrollbar class="documents-scroll-area">
      <!-- <b-row class="mx-0">
              <b-col cols="12" xl="11">
                <b-row
                  v-for="document in documents"
                  :key="document.id"
                  class="mb-4 py-1 px-4"
                >
                  <b-col cols="12" xl="4" class="d-flex align-items-center">
                    <div class="w-100 d-block">
                      test
                      <div
                        v-b-tooltip.hover
                        :title="document.name"
                        class="
                          document
                          d-flex
                          align-items-center
                          border border-raduis-sm border-color-muted
                        "
                      >
                        <span class="icon text-center text-primary mr-2">
                          <b-icon icon="file-earmark"></b-icon>
                        </span>
                        <span class="title text-truncate">
                          {{ document.name }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    cols="12"
                    xl="4"
                    class="
                      d-flex
                      align-items-center
                      justify-content-start justify-content-xl-center
                      mt-2 mt-xl-0
                    "
                  >
                    <p class="my-2 m-lg-0">
                      {{ $t("specify_content_document") }}
                    </p>
                  </b-col>
                  <b-col cols="12" xl="4" class="d-flex align-items-center">
                    <multiselect
                      v-select-overflow
                      open-direction="bottom"
                      :searchable="false"
                      :closeOnSelect="false"
                      v-model="document.types"
                      :options="getDocumentsTypes"
                      :placeholder="$t('type_document')"
                      :multiple="true"
                      trackBy="code"
                      label="name"
                      :showLabels="false"
                      class="tags-outline"
                      :isRequired="true"
                      :errorMsg="$t('required_field')"
                    >
                      <template slot="caret">
                        <div
                          class="
                            multiselect__select
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          <div
                            v-if="document.types && document.types.length"
                            class="text-primary"
                          >
                            <b-icon icon="pencil-fill"></b-icon>
                          </div>
                          <div v-else>
                            <b-icon icon="chevron-down"></b-icon>
                          </div>
                        </div>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div
                          class="option__desc d-flex justify-content-between"
                        >
                          <span class="option__title">{{
                            props.option.name
                          }}</span>
                          <span
                            class="option__info-icon right"
                            :desc="props.option.info"
                          >
                            <b-icon
                              class="text-muted"
                              icon="info-circle"
                            ></b-icon>
                          </span>
                        </div>
                      </template>
                    </multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row> -->
    </VuePerfectScrollbar>
    <!-- </b-card> -->

    <b-card
      v-if="actionType === 'edit'"
      class="border-raduis-xl border-color-muted box-shadow-sm mt-4"
      body-class="p-3"
    >
      <b-row align-v="center">
        <b-col>
          <b-button
            :disabled="isDisabled"
            @click="editDocumentType"
            pill
            variant="primary"
            class="py-2 px-5"
          >
            <span> {{ $t("save") }} </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- </b-col>
    </b-row> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { map } from "lodash";
import eventBus from "@/shared/event.bus";
import AssignDocumentOperation from "@/components/static/AddDocument/AssignDocumentOperation.vue";
import { queryConstant } from "@/shared/queryConstant";
import OperationList from "@/components/static/AddDocument/OperationList.vue";
import ConfirmModal from "@/components/static/ConfirmModal.vue";

export default {
  name: "EditDocumentType",
  components: { ConfirmModal, OperationList, AssignDocumentOperation },
  data() {
    return {
      value: [],
      selectedDocumentName: null,
      perPage: 10,
      currentPage: 1,
      length: [10, 25, 50],
      sortBy: null,
      sortDir: "asc",
      customFilter: queryConstant.setDefaultCustomFilter(),
      currentFilter: {},
      queryConfig: queryConstant.SIMULATION_OPERATION_CONFIG,
      search: "",
      selectedOperations: new Map(),
      selectedDocument: null,
      operationClick: null,
      selectedDocumentOperations: [],
      deletedDocument: null
    };
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    actionType: {
      type: String,
      default: "add"
    },
    replace: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: () => []
    },
    isSimulation: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.getDocumentsTypesAction();
    eventBus.$on("check-docs", () => {
      if (this.documents) {
        eventBus.$emit(
          "field-required",
          this.documents.some(d => !d.types || d.types.length === 0)
        );
      }
    });
    document.addEventListener("click", this.closeMenu);
  },
  methods: {
    ...mapActions("notification", ["openModal", "closeModal"]),
    ...mapMutations("document", [
      "setDraftDocuments",
      "setDraftDocumentsReplace"
    ]),
    ...mapActions("document", [
      "getDocumentsTypesAction",
      "editDocumentTypesAction",
      "deleteDraftDocumentsAction"
    ]),
    editDocumentType() {
      const editedDocs = [];
      this.documents.forEach(document => {
        const types = document.types;
        editedDocs.push({ id: document.id, types: map(types, "code") });
      });
      this.$root.$emit("bv::hide::modal", "EditDocumentTypes");
      this.editDocumentTypesAction({ documents: editedDocs });
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    deleteDraft(document) {
      const documents = this.documents.filter(
        d => d.fileName !== document.fileName
      );
      this.replace
        ? this.setDraftDocumentsReplace(documents)
        : this.setDraftDocuments(documents);
      this.deleteDraftDocumentsAction({
        documentsName: [document.fileName],
        showLoader: false
      });
      this.$emit("draft-deleted");
    },
    deleteDocument() {
      this.hideConfirmationModal();
      this.deleteDraft(this.deletedDocument);
    },
    doOpenConfirmModal(document) {
      this.deletedDocument = document;
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: "confirm-delete" });
      }, 1);
    },
    hideConfirmationModal() {
      this.$root.$emit("bv::hide::modal", "confirm-delete");
    },
    toggleMenu(documentName) {
      this.selectedDocumentName =
        this.selectedDocumentName === documentName ? null : documentName;
    },
    closeMenu(event) {
      if (!this.$el.contains(event.target)) {
        this.selectedDocumentName = null;
      }
    },
    assignDocument(document) {
      this.selectedDocumentName = null;
      if (!document.operations) {
        document.operations = [];
      }
      this.selectedDocument = document;
      if (this.selectedOperations.get(this.selectedDocument.fileName)) {
        this.selectedDocumentOperations = this.selectedOperations.get(
          this.selectedDocument.fileName
        );
      } else {
        this.selectedDocumentOperations = [];
      }
      this.selectedDocument.operations = this.selectedDocumentOperations;
      this.doOpenAssignDocumentModal();
    },
    doOpenAssignDocumentModal() {
      setTimeout(() => {
        this.openModal({
          instance: this.$root,
          id: "assignDocumentOperation"
        });
      }, 500);
    },
    handleSelectedOperations(selectedOperations) {
      this.selectedOperations.set(
        this.selectedDocument.fileName,
        selectedOperations
      );
      this.selectedDocument.operations = selectedOperations;
      this.$set(this.documents, this.documents.indexOf(this.selectedDocument), {
        ...this.selectedDocument
      });
    },
    getNbrOperations(fileName) {
      return this.selectedOperations.has(fileName)
        ? this.selectedOperations.get(fileName).length
        : 0;
    },
    showOperation(document) {
      if (this.operationClick === document.fileName) {
        this.operationClick = null;
      } else {
        this.operationClick = document.fileName;
      }
      this.selectedDocument = document;
      this.selectedDocument.operations = this.selectedOperations.get(
        document.fileName
      );
    },
    deleteOperation(operations) {
      this.selectedOperations.set(this.selectedDocument.fileName, operations);
      this.selectedDocument.operations = operations;
      if (operations.length === 0) {
        this.operationClick = null;
      }
    },
    downloadFile(doc) {
      let file = this.files.find(file => file.response === doc.fileName)?.file;
      const url = URL.createObjectURL(file);
      const elementA = document.createElement("a");
      elementA.href = url;
      elementA.download = file.name;
      document.body.appendChild(elementA);
      elementA.click();
      document.body.removeChild(elementA);
      URL.revokeObjectURL(url);
    },
    showDocument(doc) {
      const fileExtension = this.getFileExtention(doc.originalFileName);
      const isPdfOrImage = ["pdf", "jpg", "jpeg", "png", "gif", "bmp"].includes(
        fileExtension
      );
      if (isPdfOrImage) {
        let file = this.files.find(file => file.response === doc.fileName)
          ?.file;
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      } else {
        this.downloadFile(doc);
      }
    },
    isTypeDocumentSelected(doc) {
      return doc.types === null || doc.types.length === 0;
    },
    handleChangeTypes(document) {
      document.operations = [];
      if (this.selectedOperations.has(document.fileName)) {
        this.selectedOperations.delete(document.fileName);
      }
    }
  },
  watch: {
    documents() {
      if (this.documents) {
        const event =
          this.documents.some(d => !d.types || d.types.length === 0) ||
          this.documents.length === 0;
        eventBus.$emit("field-required", event);
      }
    },
    operationClick(newclick) {
      if (
        this.selectedDocument.operations &&
        this.selectedDocument.operations.length === 0
      ) {
        this.operationClick = null;
      }
    },
    deep: true
  },
  computed: {
    ...mapGetters("document", ["getDocumentsTypes", "getDraftDocuments"]),
    isDisabled() {
      let flag = false;
      if (this.documents && this.documents.length) {
        this.documents.forEach(document => {
          if (!document.types || document.types < 1) {
            flag = true;
          }
        });
      }
      return flag;
    }
  },
  beforeDestroy() {
    eventBus.$off("check-docs");
  }
};
</script>
<style lang="scss">
.documents-scroll-area {
  max-height: 340px;
}

.menu-container {
  position: relative;
  display: inline-block;
}

.menu-icon {
  cursor: pointer;
  font-size: 24px;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.3s;
}

.menu-icon:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
  position: absolute;
  top: 67%;
  left: auto;
  right: 67%;
  //transform: translateX(-100%);
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
}

.dropdown-menu button {
  background: none;
  border: none;
  width: 100%;
  padding: 10px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-menu button:hover {
  background: #f0f0f0;
}

.bg-custom {
  background-color: rgba(236, 236, 236, 0.88);
}

.no-pointer-events {
  pointer-events: none;
  cursor: not-allowed;
}
.multiselect__type {
  width: 290px !important;
}
</style>
